import script from "./BreadcrumbsManager.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsManager.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__